<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar" style="cursor:pointer">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5 trainer-dashboard">
                <div class="page-header">
                    <vs-breadcrumb align="left" :items="[
                        { title: 'You are here : ' },
                        {
                            title: 'Pending Actions',
                            active: true
                        }
                    ]"></vs-breadcrumb>
                </div>
                <div class="dashboard-grid">
                    <section class="panel panel--list">
                        <div class="panel__header">
                            <div>
                                <p class="eyebrow">Pending Actions</p>
                                <h3>Keep these trainings moving</h3>
                            </div>
                            <span class="panel__count">{{ allTrainingsdata.length }} trainings</span>
                        </div>
                        <div class="panel__search">
                            <input type="text" placeholder="Search by title..." v-model="searchQueryTraining" class="form-control search-input" />
                        </div>
                        <p class="panel__note">Click on an event to view more information.</p>
                        <ul class="panel__list">
                            <li class="list-item" v-for="(item, index) in strainingFilter" :key="index" :class="{ 'is-active': active_sp == item.training }"
                                @click="
                                    showAssesments(item.training_id);
                                    activateSubP(item.training_id);
                                ">
                                <div class="list-item__content">
                                    <div>
                                        <h6>{{ item.training.title }}</h6>
                                        <p class="list-item__dates">Start: {{ formatDate(item.training.startdate) }} · End: {{ formatDate(item.training.enddate) }}</p>
                                        <p class="list-item__location">{{ item.training.venue }} ({{ item.training.address }})</p>
                                    </div>
                                    <span class="list-item__tag">Assessment</span>
                                </div>
                            </li>
                        </ul>
                    </section>
                    <section class="panel panel--details">
                        <header class="panel__header panel__header--details">
                            <div>
                                <p class="eyebrow">Active Training</p>
                                <h3>{{ trainingSingle.title }}</h3>
                                <p class="panel__subtitle">
                                    Start Date: {{ formatDate(trainingSingle.startdate) }} · End Date: {{ formatDate(trainingSingle.enddate) }}
                                    <span class="panel__subtitle-location">{{ trainingSingle.venue }} ({{ trainingSingle.address }})</span>
                                </p>
                            </div>
                            <router-link :to="'/dashboard/Trainer/trainingAgenda?training=' + trainingSingle.training_code" class="cta-link">
                                Go to training wizard
                            </router-link>
                        </header>
                        <div class="detail-cards">
                            <article class="detail-card">
                                <p class="detail-card__label">Program Officer</p>
                                <p class="detail-card__value">{{ trainingSingle.programofficer ? trainingSingle.programofficer.name : 'N / A' }}</p>
                            </article>
                            <article class="detail-card">
                                <p class="detail-card__label">Person In-Charge</p>
                                <p class="detail-card__value">{{ trainingSingle.contact_person || 'N / A' }}</p>
                            </article>
                            <article class="detail-card">
                                <p class="detail-card__label">Contact Number</p>
                                <p class="detail-card__value">{{ trainingSingle.contact_number || 'N / A' }}</p>
                            </article>
                            <article class="detail-card">
                                <p class="detail-card__label">Venue</p>
                                <p class="detail-card__value">{{ trainingSingle.venue || 'N / A' }}</p>
                            </article>
                        </div>
                        <section class="toggle-panel">
                            <p class="toggle-panel__title">Assessment Controls</p>
                            <div class="toggle-panel__grid">
                                <div class="toggle-card">
                                    <div class="toggle-card__header">
                                        <p class="toggle-card__label">Pre Assessment</p>
                                        <vs-checkbox v-model="preAssesment" @change="handlePreChange($event)" />
                                    </div>
                                    <p class="toggle-card__hint">Toggle to enable or disable the pre assessment.</p>
                                </div>
                                <div class="toggle-card">
                                    <div class="toggle-card__header">
                                        <p class="toggle-card__label">Post Assessment</p>
                                        <vs-checkbox v-model="postAssesment" @change="handlePostChange($event)" />
                                    </div>
                                    <p class="toggle-card__hint">Toggle to enable or disable the post assessment.</p>
                                </div>
                            </div>
                        </section>
                        <section class="agenda-panel">
                            <div class="agenda-panel__header">
                                <div>
                                    <p class="eyebrow">Agenda Title</p>
                                    <h5>Plan for each day</h5>
                                </div>
                                <router-link :to="{ path: '/dashboard/Trainer/uploadTrainingMaterial', query: { training: AssigntrainingCode } }" class="cta-link cta-link--ghost">
                                    Upload Material
                                </router-link>
                            </div>
                            <div class="agenda-panel__body">
                                <vs-tabs v-if="newArr.length > 0">
                                    <vs-tab v-for="(day, index) in newArr" :key="index" :label="'Day ' + day.day">
                                        <div class="agenda-table">
                                            <div class="table-responsive">
                                                <table class="table table-borderless">
                                                    <thead>
                                                        <tr>
                                                            <th>Event Title</th>
                                                            <th>Assign Trainer</th>
                                                            <th>Title</th>
                                                            <th>Session</th>
                                                            <th>Start Time</th>
                                                            <th>End Time</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(agenda, i) in day.data" :key="i">
                                                            <td>{{ trainingSingle.title }}</td>
                                                            <td v-if="agenda.user">{{ agenda.user.name }}</td>
                                                            <td v-else>N / A</td>
                                                            <td>{{ agenda.title }}</td>
                                                            <td>{{ agenda.session }}</td>
                                                            <td>{{ agenda.fromtime }}</td>
                                                            <td>{{ agenda.totime }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </vs-tab>
                                </vs-tabs>
                                <div v-else class="agenda-panel__empty">Agenda Not found</div>
                            </div>
                        </section>
                    </section>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./main-sidebar";
import axios from "axios";
import "flatpickr/dist/flatpickr.css";
import {
    formatDate
} from "@/utils/DateFormate";

export default {
    data: () => ({
        isSidebar: false,
        trainings: [],
        preAssesment: "",
        postAssesment: "",
        traineefeedback: "",
        currentTrainingId: "",
        trainingStatus: "",
        title: "",
        traineeId: "",
        active_sp: 0,
        active_pr: 0,
        completeDiv: false,
        IncompleteDiv: false,
        preAssessment: "",
        postAssessment: "",
        searchQueryTraining: "",
        feedbackstatus: "",
        active_tr: 0,
        trainingSingle: [],
        allTrainingsdata: [],
        agendasArray: [],
        newArr: [],
        participatedTrainingCounter: 0,
        inprogressTrainingCounter: 0,
        trainee: JSON.parse(localStorage.getItem("currentUser")).name,
        AssigntrainingCode: '',
    }),
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar
    },
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        // Set the initial number of items
        // this.totalRows = this.items.length;
        this.allTrainings();
        this.showSingleTrainee();
    },
    methods: {
        formatDate,
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        handlePreChange: function (e) {
            e.stopPropagation();
            e.preventDefault();
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/enable-preassesment/" +
                    this.currentTrainingId +
                    "/" +
                    this.preAssesment

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                });
        },
        handleTrainingStatusChange: function (e) {
            e.stopPropagation();
            e.preventDefault();
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/close-training/" +
                    this.currentTrainingId +
                    "/" +
                    this.trainingStatus

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                });
        },
        handlePostChange: function (e) {
            e.stopPropagation();
            e.preventDefault();
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/enable-postassesment/" +
                    this.currentTrainingId +
                    "/" +
                    this.postAssesment

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                });
        },
        handleFeedbackChange: function (e) {
            e.stopPropagation();
            e.preventDefault();
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/enable-feedback/" +
                    this.currentTrainingId +
                    "/" +
                    this.traineefeedback

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                });
        },
        showAssesments(traingId) {

            this.currentTrainingId = traingId;
            this.trainingSingle = [];
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainer/get/training/details/" +
                    traingId +
                    "/" +
                    JSON.parse(localStorage.getItem("currentUser")).id

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.newArr = [];
                    this.agendasArray = [];
                    if (response.data && response.data.traininigSingle) {
                        this.trainingSingle = response.data.traininigSingle;
                        this.AssigntrainingCode = response.data.traininigSingle.training_code;
                        if (response.data.traininigSingle.preassesment_status != "") {
                            this.preAssesment = response.data.traininigSingle.preassesment_status;

                        }
                        if (response.data.traininigSingle.postassesment_status != "") {
                            this.postAssesment = response.data.traininigSingle.postassesment_status;
                        }
                        if (response.data.traininigSingle.feedbackstatus != "") {
                            this.traineefeedback = response.data.traininigSingle.feedbackstatus;
                        }
                        if (response.data.traininigSingle.close_status != "") {
                            this.trainingStatus = response.data.traininigSingle.close_status;
                        }
                    }

                    if (
                        response.data &&
                        response.data.agenda &&
                        response.data.agenda.length > 0
                    ) {
                        this.agendasArray = response.data.agenda;
                        this.agendasArray.forEach(val => {
                            if (this.newArr.some(person => person.day === val.days)) {
                                this.dayIndex = this.newArr.map(e => e.day).indexOf(val.days);
                                this.newArr[this.dayIndex].data.push(val);
                            } else {
                                this.newArr.push({
                                    day: val.days,
                                    data: [val]
                                });
                            }
                        });
                    }
                });
        },
        // this will load all trainigs for the sidebar cards
        allTrainings: function allTrainings() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainer/trainings/" +
                    JSON.parse(localStorage.getItem("currentUser")).id +
                    "/filter"

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data) {
                        this.allTrainingsdata = response.data;
                        if (
                            response.data &&
                            response.data[0] != undefined &&
                            response.data[0] != ""
                        ) {
                            this.showAssesments(response.data[0].training_id);
                        }
                    }
                });
        },
        // this will show single trainee info
        showSingleTrainee: function showSingleTrainee() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainee-single/" +
                    JSON.parse(localStorage.getItem("currentUser")).id +
                    "/show"

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.traineeId = response.data.id;
                    this.showAllTrainings(this.traineeId);
                });
        },
        activateSubP: function activateSubP(id) {
            this.active_sp = id;
        },
        activatePr: function activatePr(id) {
            this.active_pr = id;
        },
        activateTr: function activateTr(id) {
            this.active_tr = id;
        },
        // this will show all trainings related to a single trainee
        showAllTrainings: function showAllTrainings(traineeId) {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainee/trainings/knowledegebase/" +
                    JSON.parse(localStorage.getItem("currentUser")).id +
                    "/get/" +
                    traineeId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.inprogressTrainingCounter = 0;
                    this.participatedTrainingCounter = 0;
                    this.trainings = response.data;
                    response.data.forEach(element => {
                        if (element.status == "nofound") {
                            this.inprogressTrainingCounter++;
                        } else {
                            this.participatedTrainingCounter++;
                        }
                    });

                });
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        successUpload() {
            this.$vs.notify({
                color: "success",
                title: "Upload Success",
                text: "Files have been Uploaded, consectetur"
            });
        }
    },
    computed: {
        strainingFilter: function () {
            return this.allTrainingsdata.filter(items => {

                if (String(items.training.title).indexOf(this.searchQueryTraining) !== -1) {
                    return true;
                }

                return false;
            });
        }
    }
};
</script>

<style scoped>
#menu-toggle {
    display: none;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
    }
}

.trainer-dashboard {
    max-width: 1320px;
    margin: 0 auto;
}

.page-header {
    margin-bottom: 18px;
}

.dashboard-grid {
    display: grid;
    grid-template-columns: 320px 1fr;
    gap: 24px;
}

@media (max-width: 992px) {
    .dashboard-grid {
        grid-template-columns: 1fr;
    }
}

.panel {
    border-radius: 20px;
    padding: 24px;
    background: #fff;
    box-shadow: 0 24px 40px rgba(15, 23, 42, 0.08);
    transition: transform 0.3s ease;
}

.panel--list {
    background: linear-gradient(180deg, rgba(6, 166, 224, 0.95), rgba(5, 34, 86, 0.95));
    color: #fff;
    min-height: 100%;
}

.panel__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
}

.panel__header h3 {
    margin: 0;
    font-size: 1.5rem;
}

.eyebrow {
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.2em;
    margin: 0 0 6px;
    color: rgba(255, 255, 255, 0.8);
}

.panel__count {
    font-weight: 600;
    opacity: 0.9;
}

.panel__search {
    margin-bottom: 12px;
}

.search-input {
    background: rgba(255, 255, 255, 0.12);
    border: none;
    color: #fff;
}

.search-input::placeholder {
    color: rgba(255, 255, 255, 0.6);
}

.search-input:focus {
    box-shadow: none;
    background: rgba(255, 255, 255, 0.2);
}

.panel__note {
    font-size: 0.85rem;
    margin-bottom: 16px;
    color: rgba(255, 255, 255, 0.8);
}

.panel__list {
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 74vh;
    overflow-y: auto;
}

.list-item {
    margin-bottom: 12px;
    padding: 14px;
    border-radius: 14px;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid transparent;
    transition: all 0.2s ease;
}

.list-item.is-active {
    background: rgba(255, 255, 255, 0.16);
    border-color: rgba(255, 255, 255, 0.4);
}

.list-item__content {
    display: flex;
    justify-content: space-between;
    gap: 14px;
    align-items: flex-start;
    flex-wrap: wrap;
}

.list-item__content h6 {
    margin: 0 0 4px;
}

.list-item__dates,
.list-item__location {
    margin: 0;
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.9);
}

.list-item__tag {
    padding: 6px 12px;
    border-radius: 999px;
    font-size: 0.75rem;
    background: rgba(255, 255, 255, 0.12);
    align-self: flex-start;
}

.panel--details {
    background: #fff;
}

.panel__header--details p {
    margin: 0;
}

.panel__subtitle {
    margin: 6px 0 0;
    font-size: 0.9rem;
    color: #637381;
}

.panel__subtitle-location {
    display: inline-block;
    margin-top: 4px;
    font-weight: 600;
    color: #101828;
}

.detail-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 16px;
    margin: 20px 0;
}

.detail-card {
    border: 1px solid #e0e7ff;
    border-radius: 16px;
    padding: 16px;
    background: #f9fbff;
    min-height: 110px;
}

.detail-card__label {
    margin: 0;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #64748b;
}

.detail-card__value {
    margin: 8px 0 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: #101828;
}

.toggle-panel {
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    padding: 18px;
    background: #fff;
    margin-bottom: 20px;
}

.toggle-panel__title {
    margin: 0 0 12px;
    font-size: 1rem;
    font-weight: 600;
    color: #101828;
}

.toggle-panel__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 16px;
}

.toggle-card {
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 16px;
    background: #f8fafc;
}

.toggle-card__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.toggle-card__label {
    margin: 0;
    font-weight: 600;
    color: #0f172a;
}

.toggle-card__hint {
    margin: 0;
    font-size: 0.85rem;
    color: #475467;
}

.agenda-panel {
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    background: #fefefe;
}

.agenda-panel__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 22px;
    border-bottom: 1px solid #e2e8f0;
}

.agenda-panel__header h5 {
    margin: 0;
    font-size: 1.2rem;
}

.agenda-panel__body {
    padding: 20px;
}

.agenda-table table {
    border-collapse: collapse;
}

.agenda-table th,
.agenda-table td {
    padding: 12px 10px;
    border-bottom: 1px solid #edf2f7;
    color: #1f2937;
}

.agenda-table th {
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.08em;
    color: #64748b;
}

.agenda-panel__empty {
    text-align: center;
    padding: 40px 10px;
    color: #64748b;
}

.cta-link {
    padding: 10px 22px;
    border-radius: 999px;
    background: #0c7bdd;
    color: #fff;
    font-weight: 600;
    text-decoration: none;
    transition: background 0.2s ease;
    font-size: 0.9rem;
}

.cta-link:hover {
    background: #0959c0;
    color: #fff;
}

.cta-link--ghost {
    background: transparent;
    color: #0c7bdd;
    border: 1px solid #0c7bdd;
}

.cta-link--ghost:hover {
    background: rgba(12, 123, 221, 0.1);
}

@media (max-width: 768px) {
    .panel {
        padding: 18px;
    }

    .panel--list {
        min-height: auto;
    }

    .panel__header {
        flex-direction: column;
        align-items: flex-start;
    }

    .panel__header span {
        margin-top: 8px;
    }
}
</style>
